import {useMatchMedia as useMatchMediaSpecials} from '@specials/match-media';

const queries = {
  isMobile: '(max-width: 767px)',
  isTablet: '(min-width: 768px) and (max-width: 1359px)',
  isDesktop: '(min-width: 1360px)',

  isMiniGameUnavailable: '(max-width: 330px)',
  isMobileSmall: '(max-width: 374px)',
  isMobileMedium: '(max-width: 413px)',
  isMobileLarge: '(min-width: 414px) and (max-width: 599px)',
  isTabletMedium: '(min-width: 600px) and (max-width: 1023px)',
  isTabletLarge: '(min-width: 1024px) and (max-width: 1359px)',
  isDesktopMedium: '(min-width: 1360px) and (max-width: 1919px)',
  isDesktopLarge: '(min-width: 1920px)',

  isPortraitOrientation: 'screen and (max-width: 430px) and (orientation: portrait)',
  isLandscapeOrientation: 'screen and (max-width: 930px) and (orientation: landscape)',
} as const;

export function useMatchMedia(): Record<keyof typeof queries, boolean> {
  return useMatchMediaSpecials(queries);
}
